import { post } from '@config/api';

export function submitLeadsForm(data) {
   
  const url = `submit-leads`;
  return post(url, data);
}
